import { Box, Stack, Tooltip, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { LeafIcon } from '@synergy/theme-next';
import { PoolActionLabel, PoolRow, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ArticleCardVariantLabel } from '../components/article-card-variant-label';
import { useArticleCardContext } from '../article-card';

const StyledBox = styled(Box)(({ theme }) => ({
    ...theme.typography.caption,
    color: theme.palette.grey['800'],
    paddingBottom: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: theme.spacing(0.5),
}));

export const ArticleCardContentArticleNumber = (): ReactElement => {
    const { article } = useArticleCardContext();

    return (
        <StyledBox>
            <PoolTypography variant="caption" component="div">
                <FormattedMessage id="app.article.number.abbreviation" values={{ value: article.number }} />
            </PoolTypography>
            <PoolRow flexWrap="wrap">
                {!!article.currentSpecialPrice && (
                    <PoolActionLabel variant="small" color="error" hasSkew={false}>
                        <FormattedMessage id="app.article.specialPrice" />
                    </PoolActionLabel>
                )}
                {article.isBestPrice && (
                    <PoolActionLabel color="secondary" hasSkew={false} variant="small">
                        <FormattedMessage id="app.article.bestPrice" />
                    </PoolActionLabel>
                )}
                {article.isEcoProduct && (
                    <Tooltip title={<FormattedMessage id="app.tooltip.ecoProduct" />}>
                        <Stack>
                            <PoolActionLabel color="success" hasSkew={false} variant="small">
                                <LeafIcon sx={{ fontSize: 16 }} />
                            </PoolActionLabel>
                        </Stack>
                    </Tooltip>
                )}
                {article.hasVariants && <ArticleCardVariantLabel />}
            </PoolRow>
        </StyledBox>
    );
};
